import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import {
	CarlineSelect,
	DetalleMotivo,
	InicioEncuesta,
	MultipleCTASelection,
	MultipleOptionCTAs,
	RatingStars,
} from 'src/components';
import { RadioTextGroup } from 'src/components/inputs/RadioTextGroup';
import { LayoutTemplate } from 'src/feature-app';
import { CTAsSiNoSinRespuesta } from 'src/feature-app/InputsValues';
import { ConfirmacionCem } from 'src/forms/Cem/ConfirmacionCem';
import { FirstStepCEM } from 'src/forms/Cem/FirstStepCEM';
import { Steps } from 'src/types';
import {
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from '../helpers/data';

export const getStepsPosventaComerciales = (
	installation: string,
	carline: string,
) => {
	const optionsMotivosVisita = [
		{
			label: 'Revisión pre-ITV',
			value: '2',
		},
		{
			label: 'Avería circulando con el vehículo (el coche no pudo seguir circulando, fue necesario remolcarlo) ',
			value: '4',
		},
		{
			label: 'Me llamaron por medida de servicio',
			value: '10',
		},
		{
			label: 'Chapa y pintura (reparaciones por accidente o estéticas)',
			value: '6',
		},
		{
			label: 'Cambio de neumáticos',
			value: '3',
		},
		{
			label: 'Actualización de software',
			value: '11',
		},
		{
			label: 'Instalación de accesorios',
			value: '7',
		},
		{
			label: 'Servicio rutinario / de mantenimiento',
			value: '1',
		},
		{
			label: 'Reparación mecánica (motor, transmisión, etc)',
			value: '12',
		},
		{
			label: 'Parabrisas, ventanas y otros trabajos',
			value: '13',
		},
		{
			label: 'Tema electrónico (infoentretenimiento, conectividad, etc.)',
			value: '14',
		},
		// El campo no es required, si no seleccionamos ninguna opción enviamos 99
		/*{
			label: 'Sin respuesta',
			value: '99',
		},*/
	];

	const optionsAlternativaMovilidad = [
		{
			label: 'Sí, un vehículo Volkswagen',
			value: '1',
		},
		{
			label: 'Sí, otra alternativa (transporte público, taxi, lanzadera/shuttle…)',
			value: '2',
		},
		{
			label: 'No, pero la hubiera necesitado',
			value: '3',
		},
		{
			label: 'No, y tampoco la necesitaba',
			value: '4',
		},
	];

	const optionsUsoVehiculo = [
		{
			label: 'Exclusivamente profesional',
			value: '1',
		},
		{
			label: 'Profesional y particular (mixto)',
			value: '2',
		},
		{
			label: 'Exclusivamente particular',
			value: '3',
		},
	];

	const optionsPublicarRespuestas = [
		{
			label:
				'Sí, mis respuestas pueden ser publicadas sin mi nombre en la Web Oficial Volkswagen y en la de ' +
				installation,
			value: '1',
		},
		{
			label:
				'No, mis respuestas no pueden ser publicadas en la Web Oficial Volkswagen y en la de ' +
				installation,
			value: '2',
		},
	];

	const optionsDatosIncorrectos = [
		{
			label: 'Marca incorrecta',
			value: valueWrongMarca.toString(),
		},
		{
			label: 'Modelo incorrecto',
			value: valueWrongModelo.toString(),
		},
		{
			label: 'Servicio Oficial incorrecto',
			value: valueWrongConcesion.toString(),
		},
		{
			label: 'Persona de contacto incorrecta',
			value: valueWrongPersona.toString(),
		},
	];

	const optionsEnviarConcesion = [
		{
			value: '3',
			label: 'Sí, mis respuestas pueden ser enviadas y analizadas junto a mi nombre y al número de bastidor de mi vehículo, para el alcance descrito anteriormente. (el consentimiento puede revocarse en cualquier momento a través de los canales de contacto que se indican a continuación*)',
			info: '*Puedo revocar este consentimiento en cualquier momento sin dar motivos a mi Distribuidor para mis datos personalizados y a la marca [<a href="mailto:info-datenschutz@volkswagen.de" target="_blank">info-datenschutz@volkswagen.de</a>] para el numero de bastidor. Declaración de Privacidad de datos de VW: <a href="https://datenschutz.volkswagen.de" target="_blank">https://datenschutz.volkswagen.de</a>.',
		},
		{
			value: '2',
			label: 'Mis respuestas pueden ser enviadas pero sin mencionar mi nombre ni el bastidor del vehículo (seleccionando esta opción, el Servicio Oficial no podrá ponerse en contacto contigo en relación a tus comentarios).',
			info: 'Seleccionando esta opción, el Servicio Oficial no podrá ponerse en contacto contigo en relación a tus comentarios.',
		},
		{
			value: '0',
			label: 'No, mis respuestas solo deben ser analizadas de manera anónima (seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos)',
			info: 'Seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos.',
		},
	];

	let index = 0;
	const stepsVenta: Steps[] = [
		{
			fields: <FirstStepCEM />,
			screenIndex: index++,
			name: 'DatosCorrectos',
			alternateTitle: (
				<Text>
					¿Puedes confirmar que estos datos son correctos y que eres
					la persona que mejor nos puede informar sobre la última
					visita al taller?
				</Text>
			),
			outputs: ['datosCorrectos'],
			outputsText: ['datosCorrectos'],
		},
		{
			title: (
				<>
					Por favor,{' '}
					<Text bold>¿puedes confirmar qué dato no es correcto?</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsDatosIncorrectos}
							name="datosIncorrectos"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'DatosIncorrectos',
			outputs: ['datosIncorrectos'],
			outputsText: ['datosIncorrectos'],
			ctas: optionsDatosIncorrectos,
		},
		{
			title: <Text bold>¿Cuál es el modelo correcto?</Text>,
			fields: (
				<LayoutTemplate
					element={
						<div>
							<CarlineSelect />
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'Modelo',
			outputs: ['modelo'],
			outputsText: ['modelo'],
		},
		{
			title: (
				<>
					A continuación,{' '}
					<Text bold>
						indica tu nivel de satisfacción con cada uno de estos
						aspectos relacionados con tu visita al Servicio Oficial.
					</Text>
				</>
			),
			fields: (
				<InicioEncuesta bodyCopy="Valora del 1 al 5, siendo 1 insatisfecho/a y 5 totalmente satisfecho/a." />
			),
			screenIndex: index++,
			name: 'Explicacion',
		},
		{
			title: <Text bold>El trato recibido</Text>,
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionTrato"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTrato',
			outputs: ['satisfaccionTrato'],
			outputsText: ['satisfaccionTrato'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionTratoMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTratoMotivo',
			outputs: ['satisfaccionTratoMotivo'],
			outputsText: ['satisfaccionTratoMotivo'],
		},
		{
			title: (
				<>
					<Text bold>La organización</Text> de {installation}
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<div style={{ paddingTop: '8px' }}>
							<Text
								appearance={TokenTextAppearance.copy200}
								staticSize
							>
								Por ejemplo: el establecimiento de la cita,
								tiempos de espera en el taller, la fecha de
								entrega o el tiempo que estuvo el vehículo en el
								taller.{' '}
							</Text>
							<RatingStars
								name="satisfaccionOrganizacion"
								nextOnClick={true}
								textGood="satisfecho/a"
								textBad="insatisfecho/a"
								CTASinRespuesta
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionOrganizacion',
			outputs: ['satisfaccionOrganizacion'],
			outputsText: ['satisfaccionOrganizacion'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionOrganizacionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionOrganizacionMotivo',
			outputs: ['satisfaccionOrganizacionMotivo'],
			outputsText: ['satisfaccionOrganizacionMotivo'],
		},
		{
			title: (
				<>
					<Text bold>La calidad del trabajo realizado</Text> en tu{' '}
					{carline}
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionTrabajoRealizado"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTrabajoRealizado',
			outputs: ['satisfaccionTrabajoRealizado'],
			outputsText: ['satisfaccionTrabajoRealizado'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionTrabajoRealizadoMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTrabajoRealizadoMotivo',
			outputs: ['satisfaccionTrabajoRealizadoMotivo'],
			outputsText: ['satisfaccionTrabajoRealizadoMotivo'],
		},
		{
			title: (
				<>
					Pensando en tu última visita a {installation},{' '}
					<Text bold>
						¿cuál es tu nivel de satisfacción con nuestros servicios
						en general?
					</Text>
				</>
			),
			alternateTitle: (
				<Text bold>
					¿Cuál es tu nivel de satisfacción con nuestros servicios en
					general?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionConcesion"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionConcesion',
			outputs: ['satisfaccionConcesion'],
			outputsText: ['satisfaccionConcesion'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionConcesionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
			identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionConcesionMotivo',
			outputs: ['satisfaccionConcesionMotivo'],
			outputsText: ['satisfaccionConcesionMotivo'],
		},
		{
			title: (
				<Text bold>
					¿Hay algún aspecto con el que no estuvieras satisfecho y que
					no hayas mencionado aún?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="aspectoSatisfaccionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'AspectoSatisfaccionMotivo',
			outputs: ['aspectoSatisfaccionMotivo'],
			outputsText: ['aspectoSatisfaccionMotivo'],
		},
		{
			title: (
				<>
					¿Cuál es tu nivel de satisfacción con{' '}
					<Text bold>
						el tiempo que ha dedicado el Servicio Oficial en
						realizar los trabajos?
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionTiempo"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTiempo',
			outputs: ['satisfaccionTiempo'],
			outputsText: ['satisfaccionTiempo'],
			outputsIsStars: true,
		},
		{
			title: (
				<>
					¿Te ofreció el Servicio Oficial alguna{' '}
					<Text bold>
						alternativa de movilidad para volver al trabajo o a casa
						tras dejar tu vehículo en el taller?
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsAlternativaMovilidad}
							name="alternativaMovilidad"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'AlternativaMovilidad',
			outputs: ['alternativaMovilidad'],
			outputsText: ['alternativaMovilidad'],
			ctas: optionsAlternativaMovilidad,
		},
		{
			title: (
				<>
					Después de tu última visita,{' '}
					<Text bold>
						¿{installation} se puso en contacto contigo para
						comprobar tu nivel de satisfacción con el servicio
						recibido?
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={CTAsSiNoSinRespuesta}
							name="satisfaccionContacto"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionContacto',
			outputs: ['satisfaccionContacto'],
			outputsText: ['satisfaccionContacto'],
		},
		{
			title: (
				<>
					¿Cuál o cuáles de los aspectos de la siguiente lista fueron{' '}
					<Text bold>
						{' '}
						el motivo de tu última visita al Servicio Oficial?
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<>
							<Container
								padding={{ top: ContainerPadding.dynamic0100 }}
							>
								<Text
									appearance={TokenTextAppearance.copy200}
									staticSize
								>
									Puedes elegir tres opciones
								</Text>
							</Container>

							<MultipleOptionCTAs
								ctaValues={optionsMotivosVisita}
								name="motivosVisita"
								minSelected={0}
								maxSelected={3}
								ignoreHandleClick={true}
							/>
						</>
					}
				/>
			),
			screenIndex: index++,
			name: 'MotivosVisita',
			outputs: ['motivosVisita'],
			outputsText: ['motivosVisita'],
			ctas: optionsMotivosVisita,
		},
		{
			title: <Text bold>El uso que hace de su vehículo es...</Text>,
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsUsoVehiculo}
							name="usoVehiculo"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'UsoVehiculo',
			outputs: ['usoVehiculo'],
			outputsText: ['usoVehiculo'],
			ctas: optionsUsoVehiculo,
		},
		{
			title: (
				<>
					<Text bold>Pensando en tu actual {carline},</Text> ¿cuál es
					tu nivel de satisfacción?
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionVehiculo"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionVehiculo',
			outputs: ['satisfaccionVehiculo'],
			outputsText: ['satisfaccionVehiculo'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionVehiculoMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionVehiculoMotivo',
			outputs: ['satisfaccionVehiculoMotivo'],
			outputsText: ['satisfaccionVehiculoMotivo'],
		},
		{
			title: (
				<>
					Para finalizar,{' '}
					<Text bold>
						nos gustaría saber si podemos enviar tus respuestas,
						junto con tu nombre y el número de bastidor de tu
						vehículo, al Servicio Oficial {installation} para que
						puedan usarlos para análisis de productos adicionales.
						Puedes encontrar más información sobre el trato de tus
						datos personales en el link disponible al finalizar la
						encuesta.
					</Text>
				</>
			),
			alternateTitle: (
				<Text bold>
					Nos gustaría saber si podemos enviar tus respuestas, junto
					con tu nombre y el número de bastidor de tu vehículo, al
					Servicio Oficial...
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<RadioTextGroup
							name="enviarConcesion"
							options={optionsEnviarConcesion}
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'EnviarConcesion',
			outputs: ['enviarConcesion'],
			outputsText: ['enviarConcesion'],
			ctas: optionsEnviarConcesion,
		},
		{
			title: (
				<Text bold>
					¿Podríamos publicar tus respuestas en la web oficial de
					Volkswagen y en la de {installation} sin mencionar tu
					nombre?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<div style={{ paddingTop: '8px' }}>
							<Text
								appearance={TokenTextAppearance.copy200}
								staticSize
							>
								Para compartir tu experiencia con otros
								clientes.
							</Text>
							<RadioTextGroup
								name="publicarRespuestas"
								options={optionsPublicarRespuestas}
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'PublicarRespuestas',
			outputs: ['publicarRespuestas'],
			outputsText: ['publicarRespuestas'],
			ctas: optionsPublicarRespuestas,
		},
		{
			fields: <ConfirmacionCem />,
			screenIndex: index++,
			name: 'Confirmacion',
			outputs: ['confirmacion'],
			outputsText: ['confirmacion'],
		},
	];

	return stepsVenta;
};
